module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0054.jpg?v=54d176ca";